import { ModalProps } from "antd/lib/modal/Modal";
import { Col, Input, message, Modal, Radio, Row } from "antd";
import Style from "./index.module.scss";
import React, { useImperativeHandle, useState } from "react";
import Form, { useForm } from "rc-field-form";
import "../../../../../style/public.scss";
import ChapterSelect from "../../../../../components/ChapterSelect";
import { Can, errorMessage } from "../../../../../service/service";
import FieldWithError from "../../../../../components/FieldWithError";
import { RowProps } from "antd/es/grid";
import GoChapter from "../GoChapter";
import classNames from "classnames";
import {
    SourceItem,
    updateCoursewareSourceBase,
    UpdateSourceProps
} from "../../../../ResourcePool/service";
import useRequestFn from "../../../../../utils/useRequestFn";
import { ResultMessage } from "../../../../../components/ResultMessage";

interface DataModalInstance {
    setPayload: (payload: any) => void;
}

interface DataModalProps extends ModalProps {
    onOk?: () => void;
    onCancel?: () => void;
    onSuccess: () => void;
}

const RowAttr: RowProps = {
    gutter: 15,
    type: "flex",
    align: "middle",
    className: Style.row
};

interface FormProp {
    chapterId: string;
    isPublish: Can;
    description: string;
    isDownload: Can;
}

const EditModal = React.forwardRef<DataModalInstance, DataModalProps>(
    ({ onSuccess, onOk, onCancel, ...props }, ref) => {
        const [payload, setPayload] = useState<SourceItem>();
        useImperativeHandle(ref, () => ({
            setPayload: payload => {
                setPayload(payload);
            }
        }));
        const [form] = useForm<FormProp>();

        const [updateAction, { loading: updateLoading }] = useRequestFn(
            updateCoursewareSourceBase
        );

        if (!payload) {
            return null;
        }

        async function onFinish(data: FormProp) {
            if (payload) {
                const params: UpdateSourceProps = {
                    batchNo: payload.batchNo,
                    chapterId: data.chapterId || "0",
                    courseNo: payload.courseNo,
                    courseSeq: payload.courseSeq,
                    description: data.description,
                    id: payload.id,
                    isDownload: data.isDownload,
                    isPublish: data.isPublish,
                    weektimeId: payload.weektimeId
                };
                try {
                    await updateAction(params);
                    message.success("设置成功");
                    await onSuccess();
                } catch (e) {
                    ResultMessage.error(errorMessage(e));
                }
            }
        }

        return (
            <Modal
                {...props}
                onCancel={onCancel}
                maskClosable={false}
                confirmLoading={updateLoading}
                title="设置"
                onOk={form.submit}>
                <div className={Style.root}>
                    <Form form={form} onFinish={onFinish}>
                        <Row {...RowAttr}>
                            <Col span={5}>
                                <div className={Style.label}>发布设置：</div>
                            </Col>
                            <Col span={16}>
                                <FieldWithError
                                    preserve
                                    name="isPublish"
                                    initialValue={payload?.isPublish || Can.no}>
                                    <Radio.Group>
                                        <Radio value={Can.no}>不发布</Radio>
                                        <Radio value={Can.yes}>发布</Radio>
                                    </Radio.Group>
                                </FieldWithError>
                            </Col>
                        </Row>
                        <Row {...RowAttr}>
                            <Col span={5}>
                                <div className={Style.label}>下载设置：</div>
                            </Col>
                            <Col span={16}>
                                <FieldWithError
                                    name="isDownload"
                                    initialValue={payload?.isDownload}>
                                    <Radio.Group>
                                        <Radio value={Can.no}>
                                            禁止下载 {}
                                        </Radio>
                                        <Radio value={Can.yes}>允许下载</Radio>
                                    </Radio.Group>
                                </FieldWithError>
                            </Col>
                        </Row>
                        <Row {...RowAttr}>
                            <Col span={5}>
                                <div className={Style.label}>所属章节：</div>
                            </Col>
                            <Col span={16}>
                                <FieldWithError
                                    name="chapterId"
                                    initialValue={
                                        payload?.ownerChapter?.id || "0"
                                    }>
                                    <ChapterSelect />
                                </FieldWithError>
                            </Col>
                            <Col span={1}>
                                <GoChapter />
                            </Col>
                        </Row>
                        <Row {...RowAttr} align="top">
                            <Col span={5}>
                                <div
                                    className={classNames(
                                        Style.label,
                                        "label32"
                                    )}>
                                    课件说明：
                                </div>
                            </Col>
                            <Col span={16}>
                                <FieldWithError
                                    name="description"
                                    initialValue={payload?.description}>
                                    <Input.TextArea
                                        rows={4}
                                        maxLength={500}
                                        placeholder="输入课件说明，最多500字"
                                    />
                                </FieldWithError>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </Modal>
        );
    }
);
EditModal.displayName = "EditModal";
export default EditModal;
